import { ModalCloseButton, Text, HStack } from '@chakra-ui/react';

import {
    Modal,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Button,
} from 'components/v4';

const DeleteConfirmationModal = ({
    isOpen,
    onClose,
    registrationExtension,
    onConfirm,
    isDeleting = false,
}) => {
    const handleConfirm = () => {
        onConfirm();
    };

    return (
        <Modal
            closeOnOverlayClick={false}
            isCentered
            isOpen={isOpen}
            onClose={onClose}
            size="md">
            <ModalOverlay backdropFilter="blur(10px)" />
            <ModalContent>
                <ModalHeader>Delete TRS Registration</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <Text>
                        Are you sure you want to delete registration &quot;
                        {registrationExtension}&quot;? This action cannot be
                        undone.
                    </Text>
                </ModalBody>
                <ModalFooter>
                    <HStack spacing={3}>
                        <Button
                            variant="outline"
                            onClick={onClose}
                            isDisabled={isDeleting}>
                            Cancel
                        </Button>
                        <Button
                            colorScheme="red"
                            onClick={handleConfirm}
                            isLoading={isDeleting}
                            loadingText="Deleting...">
                            Delete
                        </Button>
                    </HStack>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default DeleteConfirmationModal;
